import { c as t, a, b as n } from "./polished.esm-Bkxb1gRj.js";
import { useBrand as o } from "./providers/BrandProvider/brandProvider.mjs";
const s = (r) => {
  const e = o();
  return r[e] || r.fallback;
}, c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  darken: t,
  lighten: a,
  transparentize: n,
  useColor: s
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as a,
  c as u
};
